import { composables } from "@socotec.io/socio-vue-components";
const socioReferencialMessages = composables.socioReferencialMessages;
import localesMessages from "./messages.json";
import documentFiltersMessages from "./document/documentFilters.json";
import documentManagementMessages from "./document/documentManagement.json";
import documentValidationMessages from "./document/documentValidation.json";
import documentContractMessages from "./document/documentContractManager.json";
import topicAnalysisPlanMessages from "./topicValidation/topicAnalysisPlans.json";
import planAnalysisRequestMessages from "./topicValidation/planAnalysisRequests.json";
import pvAnalysisMessages from "./pvAnalysis.json";
import contributorRecoveryMessages from "./contributorRecovery.json";
import workDescriptionMessages from "./workDescription.json";
import pcAtRecoveryMessages from "./pcAtRecovery.json";
import safetyReviewRecoveryMessages from "./safetyReviewRecovery.json";
import staffingRecoveryMessages from "./staffingRecovery.json";
import clearanceRecoveryMessages from "./clearanceRecovery.json";
import iaTasksMessages from "./iaTasks.json";
import audioMessages from "./audio.json";
import tasksMessages from "./tasks.json";
import vuetifyMessages from "./vuetify.json";
import referencialRapsotec from "./referencial.json";
import externalRolesMessages from "./externalRoles.json";
import itmMessages from "./itm.json";
import { en, fr, nl } from "vuetify/locale";
import { merge as _merge } from "lodash";

const mergeVuetifyLocalWithOurs = (vuetifyLocale, ourLocale) => {
  return _merge(vuetifyLocale, ourLocale);
};

export const messages = {
  en: {
    referencial_svc: socioReferencialMessages.en,
    referencial: referencialRapsotec.en,
    $vuetify: {
      ...mergeVuetifyLocalWithOurs(en, vuetifyMessages.en),
    },
    ...localesMessages.en,
    ...documentFiltersMessages.en,
    ...documentManagementMessages.en,
    ...documentValidationMessages.en,
    ...documentContractMessages.en,
    ...topicAnalysisPlanMessages.en,
    ...planAnalysisRequestMessages.en,
    ...pvAnalysisMessages.en,
    ...contributorRecoveryMessages.en,
    ...workDescriptionMessages.en,
    ...pcAtRecoveryMessages.en,
    ...safetyReviewRecoveryMessages.en,
    ...staffingRecoveryMessages.en,
    ...clearanceRecoveryMessages.en,
    ...iaTasksMessages.en,
    ...audioMessages.en,
    ...tasksMessages.en,
    ...externalRolesMessages.en,
    ...itmMessages.en,
  },
  fr: {
    referencial_svc: socioReferencialMessages.fr,
    referencial: referencialRapsotec.fr,
    $vuetify: {
      ...mergeVuetifyLocalWithOurs(fr, vuetifyMessages.fr),
    },
    ...localesMessages.fr,
    ...documentFiltersMessages.fr,
    ...documentManagementMessages.fr,
    ...documentValidationMessages.fr,
    ...documentContractMessages.fr,
    ...topicAnalysisPlanMessages.fr,
    ...planAnalysisRequestMessages.fr,
    ...pvAnalysisMessages.fr,
    ...contributorRecoveryMessages.fr,
    ...workDescriptionMessages.fr,
    ...pcAtRecoveryMessages.fr,
    ...safetyReviewRecoveryMessages.fr,
    ...staffingRecoveryMessages.fr,
    ...clearanceRecoveryMessages.fr,
    ...iaTasksMessages.fr,
    ...audioMessages.fr,
    ...tasksMessages.fr,
    ...externalRolesMessages.fr,
    ...itmMessages.fr,
  },
  nl: {
    referencial_svc: socioReferencialMessages.nl,
    referencial: referencialRapsotec.nl || {},
    $vuetify: {
      ...mergeVuetifyLocalWithOurs(nl, vuetifyMessages.nl),
    },
    ...localesMessages.nl,
    ...documentFiltersMessages.nl,
    ...documentManagementMessages.nl,
    ...documentValidationMessages.nl,
    ...documentContractMessages.nl,
    ...topicAnalysisPlanMessages.nl,
    ...planAnalysisRequestMessages.nl,
    ...pvAnalysisMessages.nl,
    ...contributorRecoveryMessages.nl,
    ...workDescriptionMessages.nl,
    ...pcAtRecoveryMessages.nl,
    ...safetyReviewRecoveryMessages.nl,
    ...staffingRecoveryMessages.nl,
    ...clearanceRecoveryMessages.nl,
    ...iaTasksMessages.nl,
    ...audioMessages.nl,
    ...tasksMessages.nl,
    ...externalRolesMessages.nl,
    ...itmMessages.nl,
  },
};
